import React from 'react';
import { Link } from 'react-router-dom';

function BooksSection() {
  return (
    <section id="books" className="books">
      <h2>Mis libros</h2>
      <div className="books-intro">
        <p>
          Mis libros pretenden ser el reflejo de mi personalidad. Emocionan, conmueven y sacan
          ese lado mágico y entrañable que todas las personas tenemos.
        </p>
        <p>
          Aquí os presento a Mimadre, Eos y Gaia. Tres preciosos álbumes ilustrados para todas
          las edades, creados con mucho cariño y respeto a los lectores. Nacen para ser leídos,
          y también para ser contados e imaginados.
        </p>
        <p>
          Son libros solidarios, respetuosos con el medio ambiente, educativos y de gran calidad.
          Además son libros con letra grande e indicados para personas con dislexia.
        </p>
        <p>
          Contribuimos con el proyecto Mensajeros de la Paz y con la Asociación Española contra el cáncer.
        </p>
      </div>
      <div className="books-grid">
        <Link to="/mimadre" className="book-card" style={{ textDecoration: 'none', color: 'inherit' }}>
          <img src="portada_mimadre.avif" alt="Portada Mimadre" className="book-cover" />
          <h3>Mimadre</h3>
          <p>Un libro infantil que narra la vida desde la perspectiva de una niña.</p>
        </Link>
        <Link to="/eos" className="book-card" style={{ textDecoration: 'none', color: 'inherit' }}>
          <img src="portada_eos_v2.JPG" alt="Portada EOS" className="book-cover" />
          <h3>EOS</h3>
          <p>La diosa griega del amanecer, adaptado para lectores con dislexia.</p>
        </Link>
        <Link to="/gaia" className="book-card" style={{ textDecoration: 'none', color: 'inherit' }}>
          <img src="portada_gaia.avif" alt="Portada Gaia" className="book-cover" />
          <h3>Gaia</h3>
          <p>Completa mi trilogía sobre la conexión con la naturaleza.</p>
        </Link>
      </div>
    </section>
  );
}

export default BooksSection;